import { render, staticRenderFns } from "./SelectAmortizationTransactionType.vue?vue&type=template&id=47fdffa8&"
import script from "./SelectAmortizationTransactionType.vue?vue&type=script&lang=ts&"
export * from "./SelectAmortizationTransactionType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47fdffa8')) {
      api.createRecord('47fdffa8', component.options)
    } else {
      api.reload('47fdffa8', component.options)
    }
    module.hot.accept("./SelectAmortizationTransactionType.vue?vue&type=template&id=47fdffa8&", function () {
      api.rerender('47fdffa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectAmortizationTransactionType.vue"
export default component.exports